import { getRequestContext } from '../context';
import { DEFAULT_THEME_MODE } from './constants';
import { readThemeModeCookie, writeThemeModeCookie } from './themeModeCookie';
import { type ThemeMode } from './types';

const isServer = () => typeof window === 'undefined';

const listeners = new Set<() => void>();

/**
 * Подписка для useSyncExternalStore — чтобы UI обновлялся после setThemeMode.
 * @kind helper
 * @param onStoreChange - колбэк при смене режима темы
 * @returns функция отписки
 */
export const subscribeThemeMode = (onStoreChange: () => void): (() => void) => {
    listeners.add(onStoreChange);

    return () => {
        listeners.delete(onStoreChange);
    };
};

const notifyThemeModeListeners = () => {
    listeners.forEach((listener) => listener());
};

const getThemeModeFromRequestContext = (): ThemeMode => {
    try {
        return getRequestContext().themeMode;
    } catch {
        return DEFAULT_THEME_MODE;
    }
};

export const getThemeMode = (): ThemeMode => {
    if (isServer()) {
        return getThemeModeFromRequestContext();
    }

    return readThemeModeCookie();
};

export const setThemeMode = (mode: ThemeMode): void => {
    if (isServer()) {
        return;
    }

    writeThemeModeCookie(mode);
    notifyThemeModeListeners();
};
